/* eslint-disable react/no-this-in-sfc */
import HighchartsReact from 'highcharts-react-official'
import React, { useEffect, useRef } from 'react'
import Highcharts from 'highcharts'
import HighchartsExporting from 'highcharts/modules/exporting'
import { SizeMeProps, withSize } from 'react-sizeme'
import { GraphType } from './ChartTypeSelect'
import { getMaxSectionSeriesValue, getSeries, getXAxisCategories, labelFormatter } from './chartUtils'
import { getCustomChartPlotOptions } from '../utils'
import { ChartYAxis } from './types'
import { CustomReportChartSection } from '../../../../../redux/context/customReports/typesSection'
import { withPrintOverrides } from './printOverrides'

HighchartsExporting(Highcharts)

interface NewCustomChartProps {
  section: CustomReportChartSection
  size?: SizeMeProps['size']
  printMode?: boolean
}

const CustomChart: React.FC<NewCustomChartProps> = ({ section, size, printMode }) => {
  const chartRef = useRef<HighchartsReact.RefObject>(null)
  const graphType = section.style?.type ?? GraphType.column
  const series = getSeries(section)
  const showDataLabels = section.style?.showDataLabels === 'true'
  const options = {
    chart: {
      type: graphType,
      width: printMode ? undefined : size?.width,
      height: printMode ? undefined : size?.height,
      animation: false
    },
    title: {
      text: ''
    },
    series,
    plotOptions: {
      ...getCustomChartPlotOptions(section?.style?.type ?? GraphType.column, section)[1]
    },
    xAxis: {
      type: 'category',
      categories: getXAxisCategories(section)
    },
    yAxis: [
      {
        title: { text: null },
        max: showDataLabels ? getMaxSectionSeriesValue(series, ChartYAxis.left) : undefined
      },
      {
        title: { text: null },
        opposite: true,
        max: showDataLabels ? getMaxSectionSeriesValue(series, ChartYAxis.right) : undefined
      }
    ],
    tooltip: {
      // Per-series pointFormatter (set in chartUtils) handles value formatting.
    },
    credits: {
      enabled: false
    },
    legend: {
      useHTML: true,
      labelFormatter() {
        return labelFormatter(this.options, this.name)
      }
    }
  } as Highcharts.Options

  const finalOptions = withPrintOverrides(options, printMode)

  useEffect(() => {
    chartRef.current?.chart?.update(finalOptions)
  }, [section])

  return (
    <div style={{ height: '100%' }}>
      <HighchartsReact
        ref={chartRef}
        highcharts={Highcharts}
        options={finalOptions}
        immutable={printMode}
        containerProps={printMode ? { style: { height: '100%' } } : undefined}
      />
    </div>
  )
}

export default withSize({ monitorHeight: true, noPlaceholder: true })(CustomChart)
